import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import { AccountPageWrapper } from "../AccountPageWrapper";
import {
  Button,
  HStack,
  Link,
  SimpleGrid,
  Spacer,
  Stack,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import { t } from "i18next";
import { CreateApiClientModal } from "./CreateApiClientModal";
import { ApiClientItem } from "./ApiClientItem";
import { ManagePermissionsModal } from "./ManagePermissionsModal";
import { AccountView } from "../../models/AccountView";
import { useStores } from "../../../shared/stores/RootStore";
import { AddIcon, ExternalLinkIcon } from "../../../shared/views/icons";
import { API_SPEC_URL } from "../../../../config";
import { useParams } from "react-router-dom";

const i18prefix = "account:Integrations";

const AccountIntegrationsPageBase: React.FC = () => {
  const accountId = useParams().accountId!;
  const { accountStore } = useStores();
  const createModal = useDisclosure();

  useEffect(() => {
    accountStore.resetIntegrations();
    accountStore.fetchApiClients(accountId);
    // eslint-disable-next-line
  }, [accountId]);

  return (
    <AccountPageWrapper
      selectedView={AccountView.Integrations}
      accountId={accountId}
    >
      <Stack px={6}>
        <Text fontSize="2xl">{t(`${i18prefix}.tab`)}</Text>

        <HStack>
          <Text>{t(`${i18prefix}.apiClients`)}</Text>
          <Button
            size="sm"
            fontSize="sm"
            variant="ghost"
            colorPalette="primary"
            onClick={() => {
              createModal.onOpen();
            }}
          >
            <AddIcon /> {t(`${i18prefix}.create`)}
          </Button>
          <Spacer />
          <Link
            color="primary.600"
            fontSize="sm"
            fontWeight="semibold"
            href={API_SPEC_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t(`${i18prefix}.specLink`)} <ExternalLinkIcon />
          </Link>
        </HStack>

        <SimpleGrid columns={{ lg: 1, xl: 2 }} gap={4}>
          {accountStore.apiClients.map((apiClient) => (
            <ApiClientItem
              key={apiClient.id}
              apiClient={apiClient}
              ManagePermissionsModal={ManagePermissionsModal}
            />
          ))}
        </SimpleGrid>
      </Stack>

      {createModal.open && (
        <CreateApiClientModal
          onClose={createModal.onClose}
          accountId={accountStore.selectedUserAccount!!.accountId}
        />
      )}
    </AccountPageWrapper>
  );
};

export const AccountIntegrationsPage = observer(AccountIntegrationsPageBase);
